import { action } from 'satcheljs';

import type { OwaNovaActionUnion } from '../types';

export const onProfileEditorInternal = action('onProfileEditorInternal', event => ({
    event,
    owaType: 'profileEditorInternal',
})) as OwaNovaActionUnion<'profileEditorInternal'>;
